import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type {
    StripeApi,
    CreatePaymentSessionRequest,
    CreatePaymentSessionResponse,
    SubscriptionListDTO,
} from '../stripe-api';

@injectable()
export class StripeApiImpl extends PsHttpService implements StripeApi {
    get options() {
        return {
            baseURL: import.meta.env.VITE_ACCOUNT_SERVICE_URI,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    async createPaymentSession(request: CreatePaymentSessionRequest): Promise<CreatePaymentSessionResponse> {
        const result = await this.post<PatSnapSuccessResponseData<CreatePaymentSessionResponse>>({
            url: '/user-service/payment/stripe/checkout-session',
            data: request,
        });
        return result as unknown as CreatePaymentSessionResponse ;
    }

    async getSubscriptionList(): Promise<SubscriptionListDTO[]> {
        const result = await this.get<PatSnapSuccessResponseData<SubscriptionListDTO[]>>({
            url: '/user-service/payment/tenant-user/subscriptions',
        });
        return result as unknown as SubscriptionListDTO[];
    }
}
